(ns dashboard.entity.document.analysis-search
  "The principle contract of the dashboard.entity component namespaces are this:
   1. All components will NOT depend on keyword references to subs and events in
      external NSes, but rather receive data as arguments, functions and callbacks.
   2. All internal reliance on the re-frame app DB must be internally contained.
   3. All re-frame app subs and events must NOT be directly referenced by outside
      NSes, but rather via GETTER and SETTER functions - the same is true of internal
      calls - prefer using parameterized functions.
   4. The entity is a UI component that may encapsulate low-level business rules on
      UI controls, but is not responsible for hydrating components with data or entrenched
      references to component namespaces. The UI is customizable, and top-level entities
      should have configurable and interchangable UI elements.

   This component namespace is an implementation of Analysis Search, with is
   performed relative to a question entity. That is, we extend the UI of
   analyis search, to provide tools to better expolre the question being
   answered."
  (:require ["react" :as react]
            [dashboard.entity.analysis.search :as analysis.search]
            [dashboard.entity.analysis.tree :as analysis.tree]))

(defn- Footer
  [checked-analyses category on-submit]
  [:footer.card-footer
   [:div.card-footer-item
    [:button.button.is-primary.is-rounded
     {:disabled (empty? checked-analyses)
      ;:class (when attaching? "is-loading")
      :on-click (fn [] (on-submit checked-analyses))}
     (cond
       (= (count checked-analyses) 1) (str "Link " (count checked-analyses) " selected analysis")
       (> (count checked-analyses) 1) (str "Link " (count checked-analyses) " selected analyses")
       :else (str "Select " category " Analyses to link"))]]])

(defn analysis-by-category-tree
  "The analysis search component augmented by context and controls for a
   Question entity."
  [{:keys [analyses
           applied-analysis-version-ids
           disabled-construct-ids
           on-submit
           question
           category
           on-click-construct
           on-click-state]}]
  (let [[selected-version-ids set-selected-version-ids] (react/useState #{})
        [use-hierarchy-context set-use-hierarchy-context] (react/useState true)
        on-select (fn [{:keys [version-id]}]
                    (set-selected-version-ids
                     ((if (contains? selected-version-ids version-id) disj conj)
                      selected-version-ids
                      version-id)))
        path [:analysis-search :questions (:content question)]]
    [:div.card
     [:div.card-content {:style {:max-height "75vh"
                                 :overflow-y "scroll"}}
      [:f> analysis.search/AnalysisSearch
       {:row-component analysis.tree/CheckboxAnalysisRow
        :path path
        :question question
        :category category
        :on-click-construct on-click-construct
        :on-click-state on-click-state
        :preselected-version-ids applied-analysis-version-ids
        :selected-version-ids selected-version-ids
        :on-select on-select
        :initial-search {:query (:content question)
                         :mode :semantic}
        :use-hierarchy-context use-hierarchy-context
        :disabled-construct-ids disabled-construct-ids
        :set-use-hierarchy-context set-use-hierarchy-context
        :search-actions [:f> analysis.search/QuestionFilterOptions
                         {:perform-search (fn []
                                            (analysis.search/perform-search
                                             {:path path
                                              :mode :semantic}
                                             (:content question))
                                            (analysis.search/set-search-query
                                             path
                                             (:content question)))
                          :question question
                          :use-hierarchy-context use-hierarchy-context
                          :set-use-hierarchy-context set-use-hierarchy-context}]}]]
     [Footer
      (filterv #(contains? selected-version-ids (:version-id %)) analyses)
      category
      on-submit]]))

(defn search-analysis-by-category-modal
  "Browse and Select Applied Analysis Modal.

   This component namespace is an implementation of Analysis Search, with is
   performed relative to a question entity. That is, we extend the UI of
   analyis search, to provide tools to better expolre the question being
   answered.

   Receives the modal context layer as a map with top-level key :ctx.
   In turn, ctx is a map with expected keys:
   - analyses
     - a list of all analysis structures that follow in data shape of
       analysis.search/all-analyses.
   - applied-analysis-version-ids
     - the ASA version IDs already added to a question.
     * the internal system will denote all anayses where the applied version is
       most recent analysis.
   - on-submit
     - a function that will emit the full structures of the selected analysis.
   - question
     - a map representing a question, with key :selected-answer and its corresponding
       data.
   - category
     - the STRING representation of the selected category of analysis
   - on-click-construct
     - the action to be taken when an analysis construct link is clicked
   - on-click-state
     - the action to be taken when an analysis state icon-button is clicked"
  [{:keys [ctx]}]
  (let [analyses @(analysis.search/all-analysis-structures)]
    (fn [_]
      [:f> analysis-by-category-tree (assoc ctx :analyses analyses)])))

